import React from "react";
import { useParams } from "react-router-dom";
import { Spin } from 'antd';
import usePolicyDetails from '../../hooks/usePolicyDetails';


function PolicyDetailPage() {
  const { policyId } = useParams();
  // Fetch policy details by policyId (policy number)
  const { data, isLoading, isError } = usePolicyDetails(policyId, !!policyId);
  const details = data?.data || data || null;
  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f6fa',
      padding: 16
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)',
        padding: '32px 24px',
        minWidth: 280,
        maxWidth: 420,
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16
      }}>
        <h2 style={{
          fontWeight: 700,
          fontSize: 24,
          marginBottom: 8,
          color: '#222',
          textAlign: 'center'
        }}>Policy Details</h2>
        <div style={{
          fontSize: 16,
          color: '#555',
          marginBottom: 8,
          wordBreak: 'break-all',
          textAlign: 'center'
        }}>Policy ID: <span style={{ fontWeight: 600 }}>{policyId}</span></div>

        {isLoading ? (
          <div style={{ padding: 18 }}><Spin /></div>
        ) : isError ? (
          <div style={{ color: '#c00' }}>Failed to load policy details.</div>
        ) : details ? (
          <div style={{ width: '100%', textAlign: 'left', marginTop: 12 }}>
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: 14 }}>{JSON.stringify(details, null, 2)}</pre>
          </div>
        ) : (
          <div style={{ color: '#666', marginTop: 12 }}>No details available for this policy.</div>
        )}
      </div>
    </div>
  );
}

export default PolicyDetailPage;
